import { render, staticRenderFns } from "./VlNewExaminations.vue?vue&type=template&id=7e4a6830&scoped=true&"
import script from "./VlNewExaminations.vue?vue&type=script&lang=js&"
export * from "./VlNewExaminations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e4a6830",
  null
  
)

export default component.exports